export const isEmailValid = function (val) {
  let emailReg = /^[a-zA-Z0-9'._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-_]+$/
  val = String(val).toLowerCase()
  let valid = emailReg.test(val)
  try {
    let parts = val.split('@')
    if (parts.length > 2) {
      return false
    }
    let localPart = String(parts[0])
    let domain = String(parts[1])
    if (
      localPart.match(/^[\.\-_]|[\.\-+]$|\.\.| /) ||
      domain.match(/^[\.\-_+]|[\.\-_+]$|\.\.| /) ||
      !domain.includes('.')
    ) {
      valid = false
    }
  } catch (err) {
    console.error(err)
  }
  return valid
}
